import ProjectRight from '../projects/ProjectRight';
import ProjectLeft from '../projects/ProjectLeft';
import SectionHeader from '../UI/SectionHeader';
import ParagraphLight from '../UI/ParagraphLight';
import CodeInline from '../UI/CodeInline';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

const ProjectsSection = props => {
    return (
        <div class='bg-black'>
            <section id="section-projects">
                <SectionHeader text={'Projects'} headerGradientStyle={'header-projects'} />
                <ProjectRight
                    projectTitle={'SwiftPlantUML'}
					myRole={'Creator'}
                    bgImage={'bg-virus'}
                    techStack={['HTML5', 'CSS3', 'GitHub', 'JS', 'Figma', 'Netlify']}
                    buttonWatchItLive={'https://github.com/MarcoEidinger/SwiftPlantUML'}
                    buttonDescription={'https://blog.eidinger.info/swiftplantuml-generate-class-diagrams-from-swift-with-swift'}
                    buttonGitHub={'https://github.com/MarcoEidinger/SwiftPlantUML'}>
                    <ParagraphLight>
                        I work on various software projects written in Swift and I frequently find myself in a situation where I have to create diagrams based on the premise of existing source code, either for documentation purposes or to explain the system design concept.
					</ParagraphLight>
					<ParagraphLight>
						UML as a general-purpose, modeling language is easy to understand and represents a standard way to visualize the design of a system. Graphical modeling tools, e.g. Visio or StarUML, are very flexible but I often find myself struggling to quickly draw the components relationship or other layout aspects.
					</ParagraphLight>
					<ParagraphLight>I discovered PlantUML which is an open-source tool to create various types of UML diagrams from a plain text language.</ParagraphLight>
					<ParagraphLight>I wanted to provide a tool for Swift developers written in Swift!</ParagraphLight>
					<ParagraphLight>And so I started working on SwiftPlantUML, a utility that is available as Xcode Source Editor Extension. This command-line tool and Swift Package enables you to generate class diagrams based on Swift source code.</ParagraphLight>
					<div class="text-secondary mb-5"><img class="object-cover" src="https://github.com/MarcoEidinger/SwiftPlantUML/raw/main/.assets/exampleDiagram.png" alt="Diagram generated by SwiftPlantUML" /></div>
                </ProjectRight>
                <ProjectLeft
                    projectTitle={'SAP SDK for iOS'}
					myRole={'Contributor'}
                    techStack={['HTML']}
                    buttonWatchItLive={'https://github.com/SAP/cloud-sdk-ios'}
                    buttonDescription={'https://developers.sap.com/topics/sap-btp-sdk-for-ios.html'}
                    buttonGitHub={'https://github.com/SAP/cloud-sdk-ios'}>
                    <ParagraphLight>
                        In early 2020 I joined as lead architect for the established SAP Business Technology Platform SDK for iOS.This Swift Package is an open-source addition to the SAP BTP SDK for iOS.
                    </ParagraphLight>
                    <ParagraphLight>
                        The  BTP SDK for iOS enables you to quickly develop your own native apps, with Swift. The SDK extends the standard Swift Apple iOS frameworks with the reusable UI components from the SAP Fiori for iOS Design Language, and provides APIs which seamlessly integrate apps with SAP BTP services.
					</ParagraphLight>
					<div class="text-secondary mb-5"><img class="object-cover" src="https://developers.sap.com/content/dam/site/developer/images/dev_iOS_SDK_diagram.svg" alt="Architecture Diagram of SAP BTP SDK for iOS" /></div>
                    <ParagraphLight>
                        Examples are:
					<ul>
						<li>- <CodeInline>FioriSwiftUI</CodeInline> as the SwiftUI implementation of the SAP Fiori for iOS Design Language, and is meant to augment and, in some cases, replace the UIKit-based implementation contained in the SAPFiori framework.</li>
						<li>- <CodeInline>FioriAR</CodeInline> as the implementation of augmented reality patterns, like AR Annotations, in the SAP Fiori for iOS Design Language.</li>
						<li>- <CodeInline>SAPCAI</CodeInline> to initiate and render conversations from SAP Conversational AI natively.</li>
					</ul>
					</ParagraphLight>
                    <ParagraphLight>
						<LiteYouTubeEmbed id="xeaZ26UT4ok" title="SAP CodeTalk - Open Source Chart Library" />
                    </ParagraphLight>
                    <ParagraphLight>
						<LiteYouTubeEmbed id="JIDXDJvNSDE" title="Test 2" />
                    </ParagraphLight>
                </ProjectLeft>
            </section>
        </div>
    );
};

export default ProjectsSection;
